import script from "./ThreadMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ThreadMessage.vue?vue&type=script&setup=true&lang=js"

import "./ThreadMessage.vue?vue&type=style&index=0&id=68a7a5f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a7a5f2"]])

export default __exports__